module.exports = __webpack_public_path__ + "static/media/profilepic.d5eaa371.jpg";